/* eslint-disable no-console */
import Papa from "papaparse";
import SignalInfo from "../model/SignalInfo";

// const infoURL = "/custom/data/AlphaClub.signal.info.csv";
const infoURL = "https://api.alphaclub.extractalpha.com/worksheets/AlphaClub.signal.info.csv";

let [data, error, loading] = [undefined, undefined, false];

/**
 * Fetch the signal info from an external HTTP resource.
 * 
 * Note: this function is an async generator, so you will need to instantiate the generator, then get the .next() value, and handle the promise.

 * @returns The parsed signal info
 */
async function* fetchData() {
  if (!loading && !error && !data) {
    loading = true;
    yield fetchSignalInfo()
      .then((result) => {
        loading = false;
        data = result;
        error = undefined;
        return { data, error, loading };
      })
      .catch((err) => {
        loading = false;
        data = undefined;
        error = err;
        console.error("Error retrieving AlphaClub signal info", error);
        return { data, error, loading };
      });
    if (data || error) {
      return;
    }
  } else {
    yield { data, error, loading };
    return;
  }
}

/**
 * Fetch the signal info from an external HTTP resource. The signal info data should be a CSV formatted-file, with the following
 * fields:
 *
 * Internal ID,Menu Path,Signal Name,Signal Provider,Category,Performance,Coverage,Capacity,Uniqueness,Correlation to all signals,Correlation within category,Countries,Delivery,Go-Live,List Price,Performance based fees available,White paper link,Logo link,SubscriptionOptionsID,Ret,Sharpe,Nstocks,DaysHold,Retrank,Sharperank,"Avg(ret,sharpe) ranks",Perfrank,Nstocksrank,DaysholdRank,Cor1Rank,Cor2Rank,Alternativenessrank,AvgUniqRank,UniqRank
 *
 * An example row follows:
 * aqis_history_weight,signal,AQIS Stock Sentiment Signal,AQIS,Sentiment,3,3,5,2,0.115055455,0.176946667,US,Quarterly,2/8/2021,75000,Inquire,https://extractalpha.com/wp-content/uploads/AQIS-Stock-Sentiment-Strategy-Extract-Alpha-White-Paper-V2-02.13.21.pdf,https://extractalpha.com/wp-content/uploads/aqis_logo.png,ProductDatabase/subscribe/AQIS,14.3,1.06,1311,60,54%,41%,47%,38%,54%,96%,38%,21%,50%,36%,13%
 *
 * @returns The parsed signal info
 */
async function fetchSignalInfo() {
  return new Promise((resolve, reject) => {
    Papa.parse(infoURL, {
      download: true,
      complete: function(parsed) {
        const rows = parsed.data.slice(1);
        const results = [];
        let row;
        for (row of rows) {
          // The first element of the row is the internal ID. If this is missing, then ignore the row altogether.
          if (row[0]) {
            results.push(new SignalInfo(row));
          }
        }
        resolve(results);
      },
      error: function(error, file, inputElem, reason) {
        console.error("Error parsing signal info", error, reason);
        reject(reason);
      },
    });
  });
}

export default fetchData;
